import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import AsyncSelect from "react-select/async";
import ContentLoader from "react-content-loader";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { useForm } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import axios from "axios";

import authHeader from "../../../services/auth-header";
import { API } from "../../../backend";
import EditInvoicesService from "../../../services/billing/editInvoicesService";
import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations";
import ButtonLoading from "../../../components/Loder/buttonLoading";
import GetCompanyInfoService from "../../../services/company/getCompanyInfoService";
import DocumentUpload from "../../../services/document/documentupload";
import ApprovalAction from "../../Approvals/ApprovalAction";
import ApprovalDetails from "../../Approvals/ApprovalDetails";



function EditInvoices({ setCustomData }) {
  const locale = localStorage.getItem('locale')

  const [schedule_id, setSchedule_Id] = useState("");
  const [invoice_number, setInvoice_Number] = useState("");
  const [creation_date, setCreation_Date] = useState("");
  const [due_date, setDue_Date] = useState(null);
  const [total_amount, setTotal_Amount] = useState("");
  const [balance_amount, setBalance_Amount] = useState("");
  const [notes, setNotes] = useState("");
  const [comments, setComments] = useState("");
  const [request_id, setRequest_Id] = useState("");
  const [invoice_source, setInvoice_Source] = useState("");
  const [invoice_status, setInvoice_Status] = useState("");
  const [billing_address, setBillingAddress] = useState("");
  const [transaction_type, setTransaction_type] = useState("");
  const [payment_method, setPayment_method] = useState("");
  const [isLoading, setIsLoading] = useState(false)
  const [successful, setSuccessful] = useState(false);
  const [invoiceId, setInvoiceId] = useState(null);
  // approval
  const [approvalTaskId, setApprovalTaskId] = useState(null);
  const [approvalHistory, setApprovalHistory] = useState([]);
  const [approvalStatus, setApprovalStatus] = useState("");
  const [approvalRequestId, setApprovalRequestId] = useState(null);

  const approvalRequest = invoiceId
    ? {
        id:
          invoice_status === "Draft"
            ? invoiceId
            : approvalTaskId, 
        status: invoice_status
      }
    : null;

  const checkBtn = useRef();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const form = useRef();
  const [loading, setLoading] = useState(false);
  const [comploading, setCompLoading] = useState(false);
  const [rowsData, setRowsData] = useState([]);
  const [attribute, setAttribute] = useState([
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
  ]);
  const [extrafiledinvoice, setExtraFiled] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [inputvalue, setValue] = useState("");
  const [selectedValue2, setSelectedValue2] = useState(null);
  const [inputvalue2, setValue2] = useState("");
  const [object_name, setObject_name] = useState('Invoice')
  const [feedefination, setFeeDefination] = useState([]);
  const FeeDefination = () => {
    let url =
      API + "contracts/feedefination-view/?feename=Manual Invoice&&active=Yes";
    axios
      .get(url, { headers: authHeader() })
      .then((response) => setFeeDefination(response.data))

  };

  useEffect(() => {
    FeeDefination();
  }, []);

  const addTableRows = () => {
    const rowsInput = {
      LineNumber: "",
      line_type: "",
      line_description: "",
      line_amount: 0,
      tax_amount: 0,
      balance_amount: 0,
    };
    setRowsData([...rowsData, rowsInput]);
  };

  const deleteTableRows = (index) => {
    const rows = [...rowsData];
    rows.splice(index, 1);
    setRowsData(rows);
    totalInvoiceAmount();
  };

  const handleChange = (index, evnt) => {
    const { name, value } = evnt.target;
    const rowsInput = [...rowsData];
    rowsInput[index][name] = value;
    setRowsData(rowsInput);
    const amount = parseFloat(rowsInput[index].line_amount) || 0;
    const tax = parseFloat(rowsInput[index].tax_amount) || 0;
    rowsInput[index].balance_amount = amount + tax;
    totalInvoiceAmount();
  };


  // const handleChange = (index, evnt) => {
  //   const { name, value } = evnt.target;
  //   const rowsInput = [...rowsData];

  //   // Convert the value to a number and validate it
  //   const numericValue = parseFloat(value);

  //   // Check if the value is a positive number
  //   if (!isNaN(numericValue) && numericValue >= 0) {
  //     rowsInput[index][name] = numericValue;
  //     setRowsData(rowsInput);

  //     // Update balance_amount
  //     const amount = parseFloat(rowsInput[index].line_amount) || 0;
  //     const tax = parseFloat(rowsInput[index].tax_amount) || 0;
  //     rowsInput[index].balance_amount = amount + tax;

  //     // Call totalInvoiceAmount to update the total invoice amount
  //     totalInvoiceAmount();
  //   } else {
  //     setErrorsVal((prevErrors) => ({
  //       ...prevErrors,
  //       [index]: 'Please enter a valid positive number',
  //     }));
  //   }
  // };

  const totalInvoiceAmount = () => {
    let total = 0;
    let tax = 0
    Object.entries(rowsData).forEach(([key, value]) => {
      if (value.tax_amount === "") {
        tax = 0
      }
      else {
        tax = value.tax_amount
      }
      total =
        parseFloat(total) +
        parseFloat(value.line_amount) +
        parseFloat(tax);
    });
    setTotal_Amount(total);
  };

  const handelInputChange2 = (value1) => {
    setValue2(value1);
  };

  const handelChange2 = (value1) => {
    setSelectedValue2(value1);
    reset({
      selectedValue2: value1,
    });
    loadInitialOptions(value1.customer_name);

    reset({
      selectedValue2: value1,
      selectedValue: value1.id,
    });
  };

  const loadOptions2 = async (inputValue2) => {
    if (inputValue2 !== "") {
      const response = await axios.get(
        API +
        `contracts/contractsactive/filter/?id=${inputValue2}&&customer_id=${selectedValue
          ? selectedValue.id === undefined
            ? ""
            : selectedValue.id
          : ""
        }`,
        { headers: authHeader() }
      );
      return response.data.data;
    }
  };

  const handelInputChange = (value) => {
    setValue(value);
  };

  const handelChange1 = (value) => {
    setSelectedValue(value);
    loadInitialOptions(value);
    reset({
      selectedValue: value,
    });
  };

  const handelDue_Date = (value) => {
    setDue_Date(value);
    reset({
      duedate: value,
    });
  };

  const loadOptions = async (inputValue) => {
    if (inputValue !== "") {
      const responseJSON = await axios.get(
        API +
        `parties/vendor/?party_type=Customer&&customer_name=${inputValue}`,
        { headers: authHeader() }
      );
      return responseJSON.data.data;
    }
  };

  const [options, setOptions] = useState([]);
  const loadInitialOptions = async (customer) => {
    if (customer !== undefined) {
      const responseJSON = await axios.get(
        API + `parties/vendor/?party_type=Customer&&customer_name=${customer}`,
        { headers: authHeader() }
      );
      setOptions(responseJSON.data.data);
    } else {
      const responseJSON = await axios.get(
        API +
        `parties/vendor/?party_type=Customer&&customer_name=${selectedValue}`,
        { headers: authHeader() }
      );
      setOptions(responseJSON.data.data);
    }
  };

  const getExtrafiled = () => {
    GetCompanyInfoService.getExtraFiled().then((response) => {
      setExtraFiled(response.data.existinvoice);
    })
  };

  useEffect(() => {
    loadInitialOptions();
  }, [selectedValue]);

  const { state } = useLocation();

  useEffect(() => {
    setIsLoading(true)
    EditInvoicesService.getInvoices(state).then((response) => {
      setBalance_Amount(response.data.balance_amount);
      setComments(response.data.comments);
      setSelectedValue(response.data.customer_name);
      setSelectedValue2(response.data.contract_id);
      setDue_Date(response.data.due_date);
      setInvoice_Number(response.data.invoice_number);
      setInvoice_Source(response.data.invoice_source);
      setInvoice_Status(response.data.invoice_status);
      setRowsData(response.data.line_items);
      setNotes(response.data.notes);
      setTransaction_type(response.data.transaction_type);
      setSchedule_Id(response.data.schedule_id);
      setCreation_Date(response.data.creation_date);
      setTotal_Amount(response.data.total_amount);
      setRequest_Id(response.data.request_id);
      setPayment_method(response.data.payment_method);
      setInvoiceId(response.data.id);
      setApprovalStatus(response.data.approval_status);
      setAttribute([
        { attribute: response.data.invoiceattribute1 },
        { attribute: response.data.invoiceattribute2 },
        { attribute: response.data.invoiceattribute3 },
        { attribute: response.data.invoiceattribute4 },
        { attribute: response.data.invoiceattribute5 },
        { attribute: response.data.invoiceattribute6 },
        { attribute: response.data.invoiceattribute7 },
        { attribute: response.data.invoiceattribute8 },
        { attribute: response.data.invoiceattribute9 },
        { attribute: response.data.invoiceattribute10 },
        { attribute: response.data.invoiceattribute11 },
        { attribute: response.data.invoiceattribute12 },
        { attribute: response.data.invoiceattribute13 },
        { attribute: response.data.invoiceattribute14 },
        { attribute: response.data.invoiceattribute15 },
      ]);
      // setTimeout(() => {
      // }, 1000);


      // Approval History
      axios.get(API + `approvals/history/${state}/`, {
        headers: authHeader(),
        params: { type: "invoice" }
      })
        .then(res => setApprovalHistory(res.data || []))
        .catch(() => setApprovalHistory([]));

      // Approval Task
      axios.get(API + `approvals/task/${state}/?type=invoice`, {
        headers: authHeader()
      })
        .then(res => {
          setApprovalTaskId(res.data.task_id);
          setApprovalRequestId(res.data.request_id);
          setApprovalStatus(res.data.status); 
        });

      reset({
        selectedValue2: response.data.contract_id,
        selectedValue: response.data.customer_name,
        duedate: response.data.due_date,
      });
      setIsLoading(false)
    })

  }, []);

  const getAddress = async () => {
    // setIsLoading(true);

    try {
      const response = await axios.get(
        API + `contracts/contract-getAddress/${selectedValue2.contract_number}/`,
        { headers: authHeader() }
      );
      setBillingAddress(response.data.address_name);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedValue2 !== null) {
      getAddress();
    }
  }, [selectedValue2]);

  const navigate = useNavigate();
  const [disablecomplete, setDisablecomplete] = useState(false);
  const handleComplte = () => {
    setCompLoading(true);
    setDisablecomplete(true);
    EditInvoicesService.invoiceComplete(state).then((response) => {
      if (response.data.success === 1) {
        setSuccessful(true);
        setCompLoading(false);
        setTimeout(() => {
          setDisablecomplete(false);
          navigate("/billing/viewinvoices", { state: state });
        }, 2000);
        toast.success(`${response.data.response}`);
      } else {
        toast.error(`${response.data.error}`);
        setDisablecomplete(false);
        setCompLoading(false);
        setSuccessful(false);
      }
    })
  };
  const [disable, setDisable] = useState(false);

  const handleRegister = () => {
    setSuccessful(false);
    setLoading(true);
    setDisable(true);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      EditInvoicesService.editInvoices(
        state,
        selectedValue2.id,
        Helper.DatePicker(due_date),
        comments,
        notes,
        transaction_type,
        total_amount,
        rowsData,
        attribute,
        payment_method
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setLoading(false);
          setTimeout(() => {
            navigate("/billing");
            setDisable(false);
          }, 2000);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setLoading(false);
          setSuccessful(false);
          setDisable(false);
        }
      })
    }
  };

  const handelClick = () => {
    navigate("/billing");
  };

  useEffect(() => {
    getExtrafiled();
  }, []);

  const onChangeextrafileds = (e, index) => {
    const { name, value } = e.target;
    const rowsInput = [...attribute];
    rowsInput[index][name] = value;
    setAttribute(rowsInput);
  };

  useEffect(() => {
    setCustomData({
      object_id: state,
      object_name: object_name
    })
  }, [object_name, setCustomData, state])

  const [currentPage, setCurrentPage] = useState(1);
  const [documents, setDocuments] = useState([]);

  const recordsPerPage = 2;

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentDocuments = documents.slice(indexOfFirstRecord, indexOfLastRecord);

  const totalPages = Math.ceil(documents.length / recordsPerPage);

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(prev => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(prev => prev - 1);
    }
  };

  useEffect(() => {
    // DocumentUpload.viewListupload().then((res) => {
    DocumentUpload.viewListuploadFilterview(invoice_number, state).then((res) => {

      console.log("res", res)
      setDocuments(res.data.data)
    }).catch((e) => {
      console.log('e', e)
    })
  }, []);

  const handleTages = () => {
    navigate('/doc')
  }

  const handleDownload = (fileUrl) => {
    const link = document.createElement('a');
    link.href = fileUrl;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div className="content container-fluid">
        <ToastContainer autoClose={2000} />
        <div className="header pb-0 pt-3">
          <div className="d-lg-flex">
            <div>
              <h5 className="mb-3">{t("Edit Invoice")}</h5>
              <h6><Link to="/billing" className="tc">{t("Invoices")}</Link> / <span>{t("Edit Invoice")}</span></h6>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-8">
            <div className="card">
              <div className="card-body">
                <div className="success"></div>
                {isLoading !== true ?
                  <Form
                    role="form text-left"
                    onSubmit={handleSubmit(handleRegister)}
                    ref={form}
                    id="addPartyForm"
                  >
                    {
                      <>
                        <input
                          type="hidden"
                          value="{{ invoice.id }}"
                          id="invoiceid"
                          name="invoiceid"
                        />
                        <input
                          type="hidden"
                          value="{{ invoice.invoice_number }}"
                          id="invoiceno"
                          name="invoiceno"
                        />
                        < div className="row">
                          <div className="">
                            <label className="col-lg-6 col-form-label required">{t("Receipt Method")} <Tooltip content={t("ReceiptMethod_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                            <div className="col-lg-12 form-group">
                              <select
                                {...register("payment_method", { required: "Receipt Method is required" })}
                                className="form-control input-lg"
                                name="payment_method"
                                value={payment_method || ""}
                                onChange={(e) => setPayment_method(e.target.value)}
                              >
                                <option value="">Select Method</option>
                                {
                                  locale === "en_US" ?
                                    <>
                                      <option value="Check">Check</option>
                                      <option value="Cash">Cash</option>
                                      <option value="Card">Card</option>
                                      <option value="ACH">ACH</option>
                                    </>
                                    :
                                    <>
                                      <option value="Cheque">Cheque</option>
                                      <option value="Cash">Cash</option>
                                      <option value="Card">Card</option>
                                      <option value="DirectDebit" >Direct Debit</option>
                                    </>
                                }
                              </select>
                              <div className="invalid-feedback d-block">
                                {errors.payment_method && errors.payment_method.message}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-xl-6">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label required">
                                {t("Customer Name")}{" "}
                                <Tooltip content={t("CustomerName_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <AsyncSelect
                                  {...register("selectedValue", {
                                    required: true,
                                  })}
                                  defaultOptions
                                  isClearable
                                  options={options}
                                  value={options.find((option) =>
                                    selectedValue2
                                      ? option.id === selectedValue2.party
                                      : selectedValue
                                  )}
                                  getOptionLabel={(e) => e.customer_name}
                                  getOptionValue={(e) => e.id}
                                  loadOptions={loadOptions}
                                  onInputChange={handelInputChange}
                                  onChange={handelChange1}
                                  name="selectedValue"
                                ></AsyncSelect>
                                <div className="invalid-feedback">
                                  {errors.selectedValue && "Customer is required"}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-6">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label required">
                                {t("Contract Number")}{" "}
                                <Tooltip content={t("ContractNumber_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <AsyncSelect
                                  {...register("selectedValue2", {
                                    required: true,
                                  })}
                                  defaultOptions
                                  isClearable
                                  value={selectedValue2}
                                  placeholder={t("Search for Contract(%for All)")}
                                  getOptionLabel={(e) => e.contract_number}
                                  getOptionValue={(e) => e.contract_number}
                                  loadOptions={loadOptions2}
                                  onInputChange={handelInputChange2}
                                  onChange={handelChange2}
                                  name="selectedValue2"
                                ></AsyncSelect>
                                <div className="invalid-feedback">
                                  {errors.selectedValue2 &&
                                    "Contract Number is required"}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-12">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label required">
                                {t("Bill to Address")}{" "}
                                <Tooltip content={t("BilltoAddress_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <span id="bill_to">{billing_address}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row"></div>
                        <div className="row"></div>
                        <div className="row">
                          <div className="form-group row">
                            <div className="col-xl-12">
                              <label className="col-lg-12 col-form-label">
                                {t("Description")}{" "}
                                <Tooltip content={t("Description_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <textarea
                                  className="form-control"
                                  id="description"
                                  value={comments}
                                  name="description"
                                  onChange={(e) => setComments(e.target.value)}
                                ></textarea>
                              </div>
                            </div>
                          </div>
                          <div className="form-group row">
                            <div className="col-xl-12">
                              <label className="col-lg-12 col-form-label">
                                {t("Notes")}{" "}
                                <Tooltip content={t("Notes_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <textarea
                                  className="form-control"
                                  id="description"
                                  value={notes}
                                  name="notes"
                                  onChange={(e) => setNotes(e.target.value)}
                                ></textarea>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group row">
                              <div className="col-xl-6">
                                <label className="col-lg-4 col-form-label text-left ">
                                  {t("Transaction Type")}{" "}
                                  <Tooltip content={t("TransactionType_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                                <select
                                  className="form-control"
                                  value={transaction_type}
                                  name="transactiontype"
                                  onChange={(e) =>
                                    setTransaction_type(e.target.value)
                                  }
                                >
                                  <option value="">
                                    {t("Select Transaction Type")}
                                  </option>
                                  <option value="Fee">{t("Fee")}</option>
                                  <option value="Rent">{t("Rent")}</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="table-responsive">
                          <div className="row pt-3">
                            <div className="col-xl-6">
                              <label className="col-form-label">
                                {t("Items")}
                              </label>
                            </div>
                            <div className="col-xl-6">
                              <div className="text-right">
                                <button
                                  type="button"
                                  className="btn btn-outline-success"
                                  onClick={addTableRows}
                                >
                                  + {t("ADD")}
                                </button>
                              </div>
                            </div>
                          </div>
                          <table id="invoice" className="table table-nowrap mb-0">
                            <thead>
                              <th>
                                {t("Line Number")}{" "}
                                <Tooltip content={t("LineNumber_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </th>
                              <th>
                                {t("Fee Type")}{" "}
                                <Tooltip content={t("Feetype_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </th>
                              <th>
                                {t("Description")}{" "}
                                <Tooltip content="Description">
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </th>
                              <th>
                                {t("Amount")}{" "}
                                <Tooltip content={t("Amount_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </th>
                              <th>
                                {t("Tax")}{" "}
                                <Tooltip content={t("Tax_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </th>
                              <th>
                                {t("Total")}{" "}
                                <Tooltip content={t("Total_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </th>
                            </thead>
                            <tbody>
                              {rowsData.map((data, index) => (
                                <tr key={index}>
                                  <td>
                                    <div className="d-xl-none tc d-md-none d-lg-none">{t("LIne Number")}
                                      {" "} <Tooltip content={t("LineNumber_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </div>
                                    <div>
                                      {index + 1}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Fee Type")}
                                      {" "}  <Tooltip content={t("Feetype_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </div>
                                    <div>
                                      <select
                                        typeof="text"
                                        className="form-control"
                                        value={data.line_type}
                                        disabled={
                                          transaction_type === "Rent" ? true : false
                                        }
                                        onChange={(evnt) =>
                                          handleChange(index, evnt)
                                        }
                                        name="line_type"
                                      >
                                        <option value="">Select Fee type</option>
                                        {feedefination.map((key) => (
                                          <option key={key.id} value={key.fee_name}>
                                            {key.fee_name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Description")}
                                      {" "} <Tooltip content="Description">
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </div>
                                    <div>
                                      <input
                                        type="text"
                                        placeholder="Description"
                                        onChange={(evnt) =>
                                          handleChange(index, evnt)
                                        }
                                        name="line_description"
                                        className="form-control"
                                        value={data.line_description}
                                      />
                                      {/* {errorsVal[index] && <div className="error-message">{errorsVal[index]}</div>} */}
                                    </div>
                                  </td>
                                  <td>
                                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Amount")}
                                      {" "} <Tooltip content={t("Amount_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </div>
                                    <div>
                                      <input
                                        type="text"
                                        // min='0'
                                        // step='.01'
                                        onChange={(evnt) =>
                                          handleChange(index, evnt)
                                        }
                                        name="line_amount"
                                        className="form-control no-spinner"
                                        value={data.line_amount}
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Tax")}
                                      {" "}  <Tooltip content={t("Tax_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </div>
                                    <div>
                                      <input
                                        type="number"
                                        min='0'
                                        step='.01'
                                        disabled
                                        onChange={(evnt) =>
                                          handleChange(index, evnt)
                                        }
                                        name="tax_amount"
                                        className="form-control"
                                        value={data.tax_amount}
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <div className="d-xl-none tc d-md-none d-lg-none">{t("Total")}
                                      {" "}<Tooltip content={t("Total_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                      </Tooltip>
                                    </div>
                                    <div>
                                      <input
                                        type="number"
                                        onChange={(evnt) =>
                                          handleChange(index, evnt)
                                        }
                                        name="balance_amount"
                                        className="form-control no-spinner"
                                        value={data.balance_amount}
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <button
                                      className="btn btn-outline-danger "
                                      onClick={() => deleteTableRows(index)}
                                    >
                                      x
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        {extrafiledinvoice.length === 0 ? (
                          ""
                        ) : (
                          <h4 className="tc mt-4">
                            {t("Additional Information")} :
                          </h4>
                        )}
                        <div className="form-group row">
                          {extrafiledinvoice.map((key, index) => (
                            <div
                              className={
                                key.enable === "True" ? "col-sm-6" : null
                              }
                            >
                              <>
                                <label
                                  style={{
                                    display:
                                      key.enable === "True" ? true : "none",
                                  }}
                                  className="col-form-label"
                                >
                                  {" "}
                                  {key.label}{" "}
                                  <Tooltip content={key.label}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                                <input
                                  id={"attribute_" + index}
                                  style={{
                                    display:
                                      key.enable === "True" ? true : "none",
                                  }}
                                  value={
                                    attribute[index]["attribute"]
                                      ? attribute[index]["attribute"]
                                      : ""
                                  }
                                  className="form-control mb-1"
                                  name="attribute"
                                  type={key.datatype}
                                  placeholder={key.label}
                                  onChange={(e) => onChangeextrafileds(e, index)}
                                />
                              </>
                            </div>
                          ))}
                        </div>
                        <div className="text-left py-3">
                          <button
                            type="button"
                            onClick={handelClick}
                            className="btn-cancel-invoice border-0 btn btn-secondary btn-gradient-primary"
                          >
                            Cancel
                          </button>
                          &nbsp;&nbsp;
                          <button
                            type="submit"
                            disabled={disable}
                            className="btn-continue border-0 btn btn-primary btn-gradient-primary btn"
                          >
                            {loading === false ? t("Update") : <ButtonLoading />}
                          </button>
                          &nbsp;&nbsp;
                          {approvalStatus === "approved" || approvalStatus === "rejected" ? (
                          <button
                            type="button"
                            className="complete_invoice border-0 btn btn-primary btn-gradient-primary"
                            onClick={handleComplte}
                            disabled={disablecomplete}
                          >
                            {comploading === false ? (
                              t("Complete")
                            ) : (
                              <ButtonLoading />
                            )}
                          </button>
                        ) : null}
                          &nbsp;&nbsp;
                        </div>
                      </>
                    }
                    <CheckButton style={{ display: "none" }} ref={checkBtn} />
                  </Form> :
                  <ContentLoader
                    viewBox="0 0 1000 550"
                    backgroundColor="rgba(0,0,0,0.06)"
                    foregroundColor="rgba(0,0,0,0.12)"
                  >
                    <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
                    <circle cx="879" cy="123" r="11" />
                    <circle cx="914" cy="123" r="11" />
                    <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
                    <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
                    <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
                    <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
                    <circle cx="880" cy="184" r="11" />
                    <circle cx="915" cy="184" r="11" />
                    <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
                    <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
                    <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
                    <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
                    <circle cx="881" cy="242" r="11" />
                    <circle cx="916" cy="242" r="11" />
                    <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
                    <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
                    <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
                    <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
                    <circle cx="882" cy="303" r="11" />
                    <circle cx="917" cy="303" r="11" />
                    <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
                    <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
                    <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
                    <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
                    <circle cx="881" cy="363" r="11" />
                    <circle cx="916" cy="363" r="11" />
                    <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
                    <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
                    <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
                    <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
                    <circle cx="882" cy="424" r="11" />
                    <circle cx="917" cy="424" r="11" />
                    <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
                    <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
                    <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
                    <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
                    <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
                    <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
                    <circle cx="882" cy="484" r="11" />
                    <circle cx="917" cy="484" r="11" />
                    <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
                    <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
                    <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
                    <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
                    <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
                    <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
                    <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
                    <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
                    <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
                    <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
                  </ContentLoader>
                }
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card">
              <div className="card-body">
                <div className=" row">
                  <div className="col-xl-6">
                    <label className="col-form-label">{t("Invoice No")}</label>
                  </div>
                  <div className="col-xl-6 text-right">
                    <label className="md-6 ">
                      <h5>{invoice_number}</h5>
                    </label>
                  </div>
                </div>
                <div className="row">
                  {isLoading !== true ?
                    <Form
                      role="form text-left"
                      onSubmit={handleSubmit(handleRegister)}
                      ref={form}
                      action="."
                      method="POST"
                      id="addPartyForm"
                    >
                      {
                        <>
                          <div className="col-xl-12">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label required">
                                {t("Due Date")}{" "}
                                <Tooltip content={t("DueDate_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <DatePicker
                                  {...register("duedate", { required: true })}
                                  className="form-control"
                                  selected={
                                    due_date ? new Date(due_date) : new Date()
                                  }
                                  onChange={(e) => handelDue_Date(e)}
                                  name="duedate"
                                  placeholderText={"mm/dd/yyyy"}
                                  showYearDropdown // year show and scrolldown alos
                                  scrollableYearDropdown
                                  showMonthDropdown
                                  dropdownMode="select"
                                />
                                <div className="invalid-feedback">
                                  {errors.duedate && "Due Date  is required"}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-12">
                            <div className="form-group row">
                              <label className="col-lg-12 col-form-label">
                                {t("Invoice Amount")}{" "}
                                <Tooltip content={t("InvoiceAmount_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <div className="col-lg-12">
                                <input
                                  readonly
                                  disabled
                                  type="text"
                                  value={total_amount}
                                  className="form-control"
                                  name="invoice_amount"
                                  id="invoice_amount"
                                  onChange={(e) =>
                                    setTotal_Amount(e.target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      }
                      <CheckButton style={{ display: "none" }} ref={checkBtn} />
                    </Form> :
                    <ContentLoader
                      viewBox="0 0 1000 550"
                      backgroundColor="rgba(0,0,0,0.06)"
                      foregroundColor="rgba(0,0,0,0.12)"
                    >
                      <rect x="51" y="45" rx="3" ry="3" width="906" height="17" />
                      <circle cx="879" cy="123" r="11" />
                      <circle cx="914" cy="123" r="11" />
                      <rect x="104" y="115" rx="3" ry="3" width="141" height="15" />
                      <rect x="305" y="114" rx="3" ry="3" width="299" height="15" />
                      <rect x="661" y="114" rx="3" ry="3" width="141" height="15" />
                      <rect x="55" y="155" rx="3" ry="3" width="897" height="2" />
                      <circle cx="880" cy="184" r="11" />
                      <circle cx="915" cy="184" r="11" />
                      <rect x="105" y="176" rx="3" ry="3" width="141" height="15" />
                      <rect x="306" y="175" rx="3" ry="3" width="299" height="15" />
                      <rect x="662" y="175" rx="3" ry="3" width="141" height="15" />
                      <rect x="56" y="216" rx="3" ry="3" width="897" height="2" />
                      <circle cx="881" cy="242" r="11" />
                      <circle cx="916" cy="242" r="11" />
                      <rect x="106" y="234" rx="3" ry="3" width="141" height="15" />
                      <rect x="307" y="233" rx="3" ry="3" width="299" height="15" />
                      <rect x="663" y="233" rx="3" ry="3" width="141" height="15" />
                      <rect x="57" y="274" rx="3" ry="3" width="897" height="2" />
                      <circle cx="882" cy="303" r="11" />
                      <circle cx="917" cy="303" r="11" />
                      <rect x="107" y="295" rx="3" ry="3" width="141" height="15" />
                      <rect x="308" y="294" rx="3" ry="3" width="299" height="15" />
                      <rect x="664" y="294" rx="3" ry="3" width="141" height="15" />
                      <rect x="58" y="335" rx="3" ry="3" width="897" height="2" />
                      <circle cx="881" cy="363" r="11" />
                      <circle cx="916" cy="363" r="11" />
                      <rect x="106" y="355" rx="3" ry="3" width="141" height="15" />
                      <rect x="307" y="354" rx="3" ry="3" width="299" height="15" />
                      <rect x="663" y="354" rx="3" ry="3" width="141" height="15" />
                      <rect x="57" y="395" rx="3" ry="3" width="897" height="2" />
                      <circle cx="882" cy="424" r="11" />
                      <circle cx="917" cy="424" r="11" />
                      <rect x="107" y="416" rx="3" ry="3" width="141" height="15" />
                      <rect x="308" y="415" rx="3" ry="3" width="299" height="15" />
                      <rect x="664" y="415" rx="3" ry="3" width="141" height="15" />
                      <rect x="55" y="453" rx="3" ry="3" width="897" height="2" />
                      <rect x="51" y="49" rx="3" ry="3" width="2" height="465" />
                      <rect x="955" y="49" rx="3" ry="3" width="2" height="465" />
                      <circle cx="882" cy="484" r="11" />
                      <circle cx="917" cy="484" r="11" />
                      <rect x="107" y="476" rx="3" ry="3" width="141" height="15" />
                      <rect x="308" y="475" rx="3" ry="3" width="299" height="15" />
                      <rect x="664" y="475" rx="3" ry="3" width="141" height="15" />
                      <rect x="55" y="513" rx="3" ry="3" width="897" height="2" />
                      <rect x="52" y="80" rx="3" ry="3" width="906" height="17" />
                      <rect x="53" y="57" rx="3" ry="3" width="68" height="33" />
                      <rect x="222" y="54" rx="3" ry="3" width="149" height="33" />
                      <rect x="544" y="55" rx="3" ry="3" width="137" height="33" />
                      <rect x="782" y="56" rx="3" ry="3" width="72" height="33" />
                      <rect x="933" y="54" rx="3" ry="3" width="24" height="33" />
                    </ContentLoader>
                  }
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                {/* <button className="btn btn-primary" type="button" onClick={handleInvoice}>Invoice Generate</button> */}
                {/* <table>
                                      <thead>
                                      <tr>
                                          <th>{t("Documents")}</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {getInvoiceDetails.map((val, index) => (
                                          <tr key={index}>
                                            <td
                                              className='hyperlink' 
                                              // onClick={(e) => downloadFile(e, PDF + `${val.invoicepdf_path}`)}
                                              // onClick={(e) => downloadFile(PDF + `${val.invoicepdf_path}`)}
                                              onClick={() => downloadFile(PDF + val.invoicepdf_path, val.invoicepdf_name)}
                                            >
                                              {val.invoicepdf_name}
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table> */}
                <h6 className="mb-3">Documents ({documents.length})</h6>
                <div className="documents-list">
                  {currentDocuments && currentDocuments.map(doc => (
                    <div className="document-item" key={doc.id}>
                      <div className="document-icon">
                        {doc.type === 'pdf' ? '📄' :
                          doc.type === 'doc' || doc.type === 'docx' ? '📝' :
                            doc.type === 'jpg' || doc.type === 'jpeg' || doc.type === 'png' ? '🖼️' :
                              '📁'}
                      </div>
                      <div className="document-info">
                        <div className="document-name">{doc.title}</div>
                        <div className="document-metadata">
                          {Helper.DateNormal(doc.uploaded_at)}
                        </div>
                        <div className="document-tags">
                          {doc.tags.split(',').map((tag, index, arr) => (
                            <span key={index} className="tag-pill"
                              onClick={() => handleTages()}>{tag.trim()}{index < arr.length - 1 ? ', ' : ''}</span>
                          ))}
                        </div>
                      </div>
                      <div className="document-actions">
                        <button className="btn-continue border-0 btn btn-primary btn-gradient-primary btn"
                          onClick={() => handleDownload(doc.file)}
                        >
                          Download
                        </button>
                      </div>
                    </div>
                  ))}
                  <div className="pagination-controls d-flex justify-content-between mt-3">
                    <button
                      className="pag-btn"
                      onClick={handlePrevious}
                      disabled={currentPage === 1}
                    >
                      Previous
                    </button>

                    <span>Page {currentPage} of {totalPages}</span>

                    <button
                      className="pag-btn"
                      onClick={handleNext}
                      disabled={currentPage === totalPages}
                    >
                      Next
                    </button>
                  </div>

                </div>

              </div>
            </div>
            {/* <div className="card mt-3">

              {approvalStatus === "approved" || approvalStatus === "rejected" ? (
                <ApprovalDetails
                  approvalHistory={approvalHistory}
                  approvalRequestId={approvalRequestId}
                />
              ) : (
                approvalRequest && (
                  <ApprovalAction
                    request={approvalRequest}
                    onSuccess={() => window.location.reload()}
                  />
                )
              )}

            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default EditInvoices;
